<template>
    <station-add-form></station-add-form>
</template>


<script>

    import StationAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            StationAddForm,
        },

    }
</script>

